import { filterSlice } from './filterSlice';

export const { updateFilterValue } = filterSlice.actions;
